import React from "react";
import { EWsrvTransform, IMediaItem } from "../../lib";
import Slider, { Settings } from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { WsrvImage } from "../Media";

export enum EHorizontalPosition {
  left = "left",
  center = "center",
  right = "right",
}

export enum EVerticalPosition {
  top = "top",
  center = "center",
  bottom = "bottom",
}

export interface IImagesCarouselSlide {
  image: IMediaItem;
  title?: string;
  subtitle?: string;
  titlePosition?: {
    horizontal?: EHorizontalPosition;
    vertical?: EVerticalPosition;
  };
}

export interface IImagesCarouselProps {
  classNames?: string;
  slides: IImagesCarouselSlide[];
  sliderSettings?: Partial<Settings>
}

export const ImagesCarouselBlade: React.FC<IImagesCarouselProps> = ({
  classNames = "",
  slides,
  sliderSettings,
}) => {
  const PrevArrow = (props: any) => {
    return (
      <button
        {...props}
        className="absolute top-1/2 z-10 cursor-pointer text-white text-6xl -mt-6 drop-shadow left-0 bg-transparent"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const NextArrow = (props: any) => {
    return (
      <button
        {...props}
        className="absolute top-1/2 z-10 cursor-pointer text-white text-6xl drop-shadow -mt-6 inline-block right-0 bg-transparent"
      >
        <FaChevronRight />
      </button>
    );
  };

  return (
    <>
      {slides.length > 0 && (
        <Slider
          className="w-full h-full flex flex-col justify-center"
          slidesToShow={1}
          slidesToScroll={1}
          arrows={slides.length > 1}
          dots={false}
          nextArrow={<NextArrow />}
          prevArrow={<PrevArrow />}
          {...sliderSettings}
        >
          {slides.map((slide, index) => (
            <div
              key={index}
              className="flex flex-col w-full relative items-center"
            >
              <WsrvImage
                urlParams={{
                  originURL: slide.image.url,
                  preset: EWsrvTransform.cover16x9
                }}
                className="w-full"
                imgProps={{
                  className: "h-screen w-full object-cover z-0",
                  wrapperClassName: "w-full"
                }}
              />
              <div
                className={`title-wrapper absolute py-4 px-4 md:py-11 md:px-11 ${slide.titlePosition?.vertical === EVerticalPosition.top
                  ? "top-0"
                  : slide.titlePosition?.vertical === EVerticalPosition.bottom
                    ? "bottom-0"
                    : "top-1/2 transform -translate-y-1/2 py-0"
                  } ${slide.titlePosition?.horizontal === EHorizontalPosition.left
                    ? "left-0"
                    : slide.titlePosition?.horizontal === EHorizontalPosition.right
                      ? "right-0 text-right"
                      : "left-1/2 text-center transform -translate-x-1/2 px-0 "
                  } z-10`}
              >
                {slide.title && (
                  <h2 className="text-composite-text">
                    {slide.title}
                  </h2>
                )}
                {slide.subtitle && (
                  <h3 className="text-composite-text">
                    {slide.subtitle}
                  </h3>
                )}
              </div>
            </div>
          ))}
        </Slider>
      )}
    </>
  );
};

export default ImagesCarouselBlade;
